const allowedLwsDomains = ['synchronycredit.com', 'amazon.com', 'samsclub.com']

const isLwsEnabledForClients = (uri: string) => {
  if (!uri) return false
  return allowedLwsDomains.some((allowedLwsDomain) =>
    uri.includes(allowedLwsDomain)
  )
}

export default isLwsEnabledForClients
